import { Autocomplete, TextField } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import FormDialog from "../ProjectActivity/FormDialog";
import { updateAction } from "../../../Config/db/actions.retrieve";
import { ProjectContext } from "../../../AppContext/ProjectContext";

export default function ActionForm({
  fieldPicked,
  open,
  handleClose,
  populdateData,
}) {
  const [changes, setChanges] = useState({});
  const { participants } = useContext(ProjectContext);

  /* Quick status update — fire immediately, no dialog needed */
  useEffect(() => {
    if (fieldPicked?.startsWith("status-") && populdateData?.id) {
      const newStatus = fieldPicked.replace("status-", "");
      updateAction(populdateData.id, { status: newStatus }).then(() => handleClose());
    }
  }, [fieldPicked, populdateData?.id]);

  const syncChanges = () => {
    updateAction(populdateData.id, changes).then(() => {
      handleClose();
    });
  };

  /* Build participant list for assignment */
  const memberOptions = React.useMemo(() => {
    if (!participants) return [];
    return Object.values(participants).map((p) => ({
      uid: p.uid,
      label: p.displayName || p.email || p.uid,
    }));
  }, [participants]);

  if (fieldPicked === "edit") {
    return (
      <FormDialog
        title="Edit Task Name"
        open={open}
        handleClose={handleClose}
        postiveButtonCallback={syncChanges}
      >
        <TextField
          fullWidth
          defaultValue={populdateData.taskName}
          label="Task Name"
          placeholder="Enter task name"
          onChange={(event) =>
            setChanges((prev) => ({ ...prev, taskName: event.target.value }))
          }
          sx={{ mt: 1 }}
        />
      </FormDialog>
    );
  }

  if (fieldPicked === "estimate") {
    return (
      <FormDialog
        title="Update Estimate"
        open={open}
        handleClose={handleClose}
        postiveButtonCallback={syncChanges}
      >
        <TextField
          fullWidth
          defaultValue={populdateData.estimate}
          label="Estimate"
          placeholder="e.g. 2h 30m"
          onChange={(event) =>
            setChanges((prev) => ({ ...prev, estimate: event.target.value }))
          }
          sx={{ mt: 1 }}
        />
      </FormDialog>
    );
  }

  if (fieldPicked === "assign") {
    const currentAssignee = memberOptions.find((m) => m.uid === populdateData?.assigneeId) || null;
    return (
      <FormDialog
        title="Assign Task"
        open={open}
        handleClose={handleClose}
        postiveButtonCallback={syncChanges}
      >
        <Autocomplete
          options={memberOptions}
          defaultValue={currentAssignee}
          getOptionLabel={(opt) => opt.label}
          isOptionEqualToValue={(opt, val) => opt.uid === val.uid}
          onChange={(_, selected) =>
            setChanges((prev) => ({
              ...prev,
              assigneeId: selected?.uid || null,
              assigneeName: selected?.label || null,
            }))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Assign to"
              placeholder="Search community member…"
              sx={{ mt: 1 }}
            />
          )}
          fullWidth
          size="small"
        />
      </FormDialog>
    );
  }

  return null;
}
